import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import img from '../Assets/Group 1000005966.png'
import icon6 from '../Assets/villa-svgrepo-com 1.png'
import GetSeodata from '../Components/GetSeodata'

function WhyUs() {
  return (
    <>
        <Navbar/>
        <GetSeodata PageName={'whyus'} />
        <div className='about-div'>
        <h1 style={{textAlign:'center'}}>Why Choose Us</h1>
        <p><i>Home - Why Choose Us</i></p>

        </div>
        <div className='ABOUT-div-l'>
        <div className='ABOUT-div-left'>
        <img src={img}/>

</div>
  <div className='ABOUT-div-right'>
  <h3>Why Choose Explera Vacations Co., Ltd.?</h3>
 

  <p>At Explera Vacations Co., Ltd., we go beyond conventional travel planning to create extraordinary experiences tailored to the unique needs and dreams of every traveler. Whether you’re seeking a romantic escape, an adventurous getaway, or a seamless corporate retreat, we are dedicated to making your travel unforgettable. Here’s why we stand out as a leading Destination Management Company (DMC) in Thailand and beyond:</p>

</div>
        </div>
        <div className='whyus-cards'>
        <div className='whyus-card'>
        <img src={icon6}/>
        <br/>
        <h3>Expertise You Can Trust</h3>
        <p>	Local Knowledge: With our deep roots in Thailand, we offer access to hidden gems, authentic experiences, and cultural insights that other providers might overlook.
<br/>	Experienced Team: Our travel specialists bring over 13 years of industry expertise, ensuring every journey is seamless, enjoyable, and perfectly planned.
</p>

</div>
      <div className='whyus-card'>
        <img src={icon6}/>
        <br/>
        <h3>Personalized Travel Solutions</h3>
        <p>Tailor-Made Itineraries: Every trip we plan is customized to suit your interests, preferences, and budget. Whether you’re looking for relaxation, adventure, or cultural immersion, we design the perfect itinerary for you.
<br/>Flexible Packages: From family vacations to honeymoons and corporate travel, our packages adapt to your needs and offer flexibility to make your trip stress-free.
</p>

</div>

      <div className='whyus-card'>
        <img src={icon6}/>
        <br/>
        <h3>Exceptional Service</h3>
        <p>	24/7 Support: Our team is available around the clock to assist you before, during, and after your trip, ensuring peace of mind at every stage.
<br/>Attention to Detail: From securing flight bookings to arranging luxury private transfers, we handle every aspect of your travel with precision and care.
</p>

</div>
      <div className='whyus-card'>
        <img src={icon6}/>
        <br/>
        <h3>Wide Range of Offerings</h3>
        <p>	Diverse Destinations: Explore Thailand’s most popular destinations, including Phuket, Krabi, Pattaya, and beyond.
<br/>Activities for Everyone: Choose from a wide array of experiences such as adventure tours, luxury cruises, island hopping, and cultural excursions.
<br/>All-Inclusive Options: From accommodation and transportation to fine dining and entertainment, we provide all-inclusive packages for a stress-free experience.
</p>

</div>
      <div className='whyus-card'>
        <img src={icon6}/>
        <br/>
        <h3>Commitment to Quality</h3>
        <p>	Trusted Partnerships: We collaborate with carefully vetted hotels, transport providers, and local guides to ensure a premium experience for every traveler.
<br/>	Safety First: All tours, transfers, and activities are thoroughly evaluated for safety, comfort, and reliability.
</p>

</div>
   <div className='whyus-card'>
        <img src={icon6}/>
        <br/>
        <h3>Sustainable and Responsible Tourism</h3>
        <p>	Eco-Friendly Travel Options: We actively promote activities and itineraries that respect nature, reduce environmental impact, and uphold local traditions.
<br/>	Community Support: By working with local businesses, we contribute to the growth and well-being of the communities we visit, ensuring sustainable tourism practices.
</p>

</div>
<div className='whyus-card'>
        <img src={icon6}/>
        <br/>
        <h3>Affordable Luxury</h3>
        <p>	Competitive Pricing: Enjoy premium services without exceeding your budget. Our transparent pricing ensures you receive maximum value for your investment.
<br/>	Exclusive Deals: Take advantage of our seasonal discounts, group offers, and tailored promotions designed to provide luxury at unbeatable rates.

</p>

</div>
<div className='whyus-card'>
        <img src={icon6}/>
        <br/>
        <h3>Customer Satisfaction Guaranteed</h3>
        <p>		Positive Reviews: Hundreds of satisfied clients trust and recommend us, making us a preferred choice for travelers across Russia, the Middle East, Asia, and Europe.
<br/>	Memorable Experiences: We don’t just create itineraries—we craft journeys filled with moments that leave a lasting impact.

</p>

</div>

        </div>
        <Footer/>
    </>
  )
}

export default WhyUs